(() => {
  'use strict';
  if (window.__emsAssistantBootstrap) return;
  window.__emsAssistantBootstrap = true;

  // Policy answers reviewed against EMIS public pages on 30 September 2026.
  const faqs = [
    { id: 'contact', title: 'How can I contact EMIS+?', match: /\b(contact|whatsapp|email|phone|human|opening hours|support hours)\b|talk to|speak to|cancel|change my order|payment|invoice/i, answer: 'Contact EMIS+ on WhatsApp at +65 8139 8668 or email hello@emis.asia. For help with an existing order, keep your order ID ready for the team. Ask the team about cancellations, order changes, payment questions or support hours.', sources: ['contact'], handoff: true },
    { id: 'singapore_delivery', title: 'How long does Singapore delivery take?', match: /delivery|deliver|dispatch|arriv|how long|shipping|ship/i, answer: 'Business-day orders placed before noon SGT are dispatched that day under our shipping policy. Most Singapore orders arrive within 2 to 3 business days. These are estimates. Please contact the team if you need a specific arrival date.', sources: ['shipping'] },
    { id: 'urgent_delivery', title: 'Can you help with urgent supplies?', match: /\b(urgent|urgently|expedite|expedited|emergency|today|same day|same-day|tomorrow)\b/i, answer: 'For urgent stoma or wound-care supplies, WhatsApp +65 8139 8668 to ask the team about expedited arrangements. The team needs to confirm availability, timing and any extra charge.', sources: ['shipping'], handoff: true },
    { id: 'international_shipping', title: 'Do you ship internationally?', match: /\b(international|overseas|abroad|malaysia|indonesia|australia|usa|duties|customs|import)\b|ship to/i, answer: 'EMIS+ ships internationally from Singapore. Our policy lists over 50 countries, including Malaysia, Indonesia, Australia and the USA. International rates depend on weight and destination and are calculated at checkout. Customers pay applicable destination duties or taxes. Ask the team to confirm whether your particular product can ship to your country.', sources: ['shipping'], handoff: true },
    { id: 'shipping_price', title: 'What does shipping cost?', match: /free (shipping|delivery)|shipping (cost|fee|charge|price)|delivery (cost|fee|charge|price)|how much.*(ship|deliver)|minimum spend/i, answer: 'Check the current shipping charge shown for your order, or contact the EMIS+ team. A fixed Singapore delivery fee or free-shipping threshold is not confirmed here. International shipping is calculated at checkout by weight and destination.', sources: ['shipping'], handoff: true },
    { id: 'tracking', title: 'Where is my order or tracking?', match: /\b(track|tracking|shipped|order status)\b|where.*order|my order|order (number|id)|order\s*#|not (arrived|received)|haven.t (arrived|received)/i, answer: 'Tracking is provided after an order ships. You can check your account or contact EMIS+ with your order ID if you need an update. I cannot see your personal order status. For a Shopee, Lazada or TikTok purchase, check that platform’s order page or contact our team.', sources: ['product-faq', 'contact'], account: true, handoff: true },
    { id: 'hygiene_returns', title: 'Can I return a medical or hygiene item?', match: /\b(return|returns|refund|refunds|hygiene|opened|unopened)\b/i, answer: 'Our refund policy restricts returns of wound dressings, bandages, gels, supplements, compression stockings and skin creams. It also restricts ostomy bags, baseplates and pastes, with an exception stated for completely sealed, unopened boxes. Contact the team to check your item’s eligibility and obtain return authorization before sending it back.', sources: ['refund'], handoff: true },
    { id: 'hardware_exchanges', title: 'Can I exchange the wrong hardware size or model?', match: /\b(exchange|exchanges|hardware)\b|wrong (size|model)|change of mind/i, answer: 'For eligible non-hygiene hardware, contact EMIS+ within seven days of receipt. Items must be unopened, in original packaging and resellable. The policy lists a S$10 administration fee for change-of-mind exchanges. The team must confirm eligibility before you return anything.', sources: ['refund'], handoff: true },
    { id: 'incorrect_damaged_orders', title: 'What if my delivery is wrong or damaged?', match: /\b(damaged|broken|leaking|incorrect)\b|wrong item|wrong product|missing item/i, answer: 'Contact EMIS+ with your order ID and a photo. Our policy offers a free exchange for an incorrect item and a replacement or refund for transit damage. The team will confirm the remedy and give return authorization before you send anything back. Ask the team to investigate a missing item.', sources: ['refund'], handoff: true },
    { id: 'authenticity', title: 'Where do your products come from?', match: /\b(authentic|authenticity|genuine|original|distributor|counterfeit|fake|sourcing|certified|certification)\b/i, answer: 'EMIS+ states that it sources products from official distributors and brand owners. For a specific item, ask the team about its reference code, packaging, batch or expiry details.', sources: ['home', 'product-faq'], handoff: true },
    { id: 'availability', title: 'Is a product or option in stock?', match: /\b(stock|availability|available|restock|expiry|expiration|expire)\b|sold out/i, answer: 'Search by product name, brand or reference code to check current catalogue availability. Open the product page to check your exact option. Ask the team to confirm quantities, restock timing, batch or expiry details.', sources: ['terms'], handoff: true },
    { id: 'product_selection', title: 'How do I choose the right product reference?', match: /\b(reference|convexity|stoma size|suitable|suitability|treatment|diagnose|diagnosis|dosage|prescribe|safe|pregnant|infection|infected|bleeding|pain|cure)\b|which.*(stoma|ostomy)|how.*(use|apply)|can i use/i, answer: 'The EMIS+ team can help match a product reference code. Compare the REF on your current box with the product option. Confirm stoma size, convexity and clinical suitability with your stoma-care nurse or doctor, and follow the manufacturer instructions. For medical questions, please speak with your clinician.', sources: ['product-faq'], handoff: true },
    { id: 'locations', title: 'Where are you located? Can I collect an order?', match: /\b(address|location|office|warehouse|walk-in|walk in|pickup|pick-up|collection|collect)\b|visit (your|the|a|our) (shop|store|office|warehouse)|physical (shop|store)/i, answer: 'Corporate office: 7 Temasek Boulevard, #12-07, Suntec Tower One, Singapore 038987. Warehouse and fulfilment: 38 Ang Mo Kio Industrial Park 2, Lobby A, Level 3, Singapore 569511. Contact the team before visiting to confirm access, hours or any collection arrangement.', sources: ['contact'], handoff: true }
  ];
  const priority = ['incorrect_damaged_orders', 'hardware_exchanges', 'hygiene_returns', 'locations', 'shipping_price', 'urgent_delivery', 'international_shipping', 'tracking', 'contact', 'authenticity', 'product_selection', 'availability', 'singapore_delivery'];
  const sourceLabels = { shipping: 'Shipping policy', refund: 'Refund policy', contact: 'Contact EMIS+', terms: 'Terms of service', home: 'EMIS+ product sourcing', 'product-faq': 'Product FAQ', 'home-visits': 'Nursing and home visits' };
  const stopwords = new Set(('a an and are at be can could do does for from get got have hello hi how i im in is it me more my of on or please product products search show tell that the their there these this to want what whats when where which with would you your about find looking buy buying order price prices cost costs much stock available availability details information need sell selling carry brand sku ref').split(' '));

  function init(root) {
    if (root.dataset.emsAssistantReady) return;
    const dialog = root.querySelector('dialog');
    const launcher = root.querySelector('[data-ems-assistant-open]');
    const input = root.querySelector('[data-ems-assistant-input]');
    const form = root.querySelector('[data-ems-assistant-form]');
    const transcript = root.querySelector('[data-ems-assistant-transcript]');
    const scroller = root.querySelector('[data-ems-assistant-scroll]');
    const status = root.querySelector('[data-ems-assistant-status]');
    const send = root.querySelector('[data-ems-assistant-send]');
    if (!dialog || typeof dialog.showModal !== 'function' || !launcher || !input || !form || !transcript) return;
    root.dataset.emsAssistantReady = 'true';
    let busy = false;
    let controller = null;
    let sequence = 0;
    let returnFocus = launcher;
    const currency = /^[A-Z]{3}$/.test(root.dataset.currency || '') ? root.dataset.currency : 'SGD';
    const locale = document.documentElement.lang || 'en-SG';

    function safeUrl(value, allowWhatsApp = false) {
      if (!value || typeof value !== 'string') return null;
      try {
        const url = new URL(value, window.location.origin);
        if ((url.protocol === 'https:' || url.protocol === 'http:') && url.origin === window.location.origin && !url.username && !url.password) return url;
        if (allowWhatsApp && url.protocol === 'https:' && url.hostname === 'wa.me' && url.pathname === '/6581398668' && !url.username && !url.password) return url;
      } catch (_) { /* Ignore malformed catalogue URLs. */ }
      return null;
    }

    const route = safeUrl(window.Shopify?.routes?.root || root.dataset.routeRoot || '/');
    const routeRoot = route ? route.pathname.replace(/\/?$/, '/') : '/';
    function endpoint(path) { return new URL(routeRoot + path, window.location.origin); }
    function node(tag, className, value) {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (value !== undefined) el.textContent = String(value);
      return el;
    }
    function link(label, value, allowWhatsApp = false) {
      const url = safeUrl(value, allowWhatsApp);
      if (!url) return null;
      const el = node('a', '', label);
      el.href = url.href;
      if (url.origin !== window.location.origin) { el.target = '_blank'; el.rel = 'noopener noreferrer'; }
      return el;
    }
    function scrollToLatest() { scroller.scrollTop = scroller.scrollHeight; }
    function message(text, visitor = false) {
      const item = node('li', 'ems-assistant__message' + (visitor ? ' ems-assistant__message--visitor' : ''));
      item.append(node('span', 'ems-assistant__message-label', visitor ? 'You' : 'EMIS+'));
      if (text) item.append(node('p', '', text));
      transcript.append(item);
      while (transcript.children.length > 40) transcript.firstElementChild.remove();
      scrollToLatest();
      return item;
    }
    function helpfulLinks(item, account = false) {
      const group = node('div', 'ems-assistant__help');
      if (account) { const accountLink = link('Open my account', root.dataset.accountUrl); if (accountLink) group.append(accountLink); }
      const team = link('Ask the EMIS+ team on WhatsApp', 'https://wa.me/6581398668', true);
      if (team) group.append(team);
      item.append(group);
      scrollToLatest();
    }
    function answerFaq(faq) {
      const item = message(faq.answer);
      const sources = node('div', 'ems-assistant__sources');
      faq.sources.forEach(id => {
        const source = link(sourceLabels[id], root.getAttribute('data-source-' + id));
        if (source) sources.append(source);
      });
      if (sources.childElementCount) item.append(sources);
      if (faq.handoff || faq.account) helpfulLinks(item, faq.account);
      scrollToLatest();
    }
    function setBusy(value, label = '') {
      busy = value;
      send.disabled = value;
      status.textContent = label;
      form.setAttribute('aria-busy', String(value));
    }
    function syncViewport() {
      const viewport = window.visualViewport;
      root.style.setProperty('--assist-viewport-height', (viewport?.height || window.innerHeight) + 'px');
      root.style.setProperty('--assist-keyboard-offset', Math.max(0, window.innerHeight - (viewport?.height || window.innerHeight) - (viewport?.offsetTop || 0)) + 'px');
    }
    function open() {
      if (dialog.open) return;
      returnFocus = launcher;
      syncViewport();
      dialog.showModal();
      launcher.setAttribute('aria-expanded', 'true');
      input.focus({ preventScroll: true });
    }
    function closed() {
      sequence += 1;
      if (controller) controller.abort();
      controller = null;
      setBusy(false);
      root.querySelectorAll('[data-ems-product-detail]').forEach(button => { button.disabled = false; });
      launcher.setAttribute('aria-expanded', 'false');
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    }
    function formatPrice(value, cents = false) {
      if (value === null || value === undefined || value === '') return null;
      const amount = Number(value) / (cents ? 100 : 1);
      if (!Number.isFinite(amount) || amount < 0) return null;
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount); }
      catch (_) { return currency + ' ' + amount.toFixed(2); }
    }
    function priceRange(product, cents = false) {
      const minimum = product.price_min ?? product.price;
      const maximum = product.price_max ?? product.price;
      const low = formatPrice(minimum, cents);
      const high = formatPrice(maximum, cents);
      if (!low) return 'Check product page for price';
      return high && Number(maximum) > Number(minimum) ? low + ' to ' + high : low;
    }
    function stockLabel(available, options = false) {
      if (available === true) return options ? 'Some options available to order' : 'Available to order';
      if (available === false) return 'Currently unavailable';
      return 'Check product page for availability';
    }
    function normalizedHandle(value) {
      if (typeof value !== 'string') return null;
      let handle;
      try { handle = decodeURIComponent(value); } catch (_) { return null; }
      if (!handle || handle.length > 255 || handle === '.' || handle === '..' || /[/\\?#\u0000-\u0020\u007f]/u.test(handle)) return null;
      return handle;
    }
    function cleanQuery(question) {
      return question.toLowerCase().replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/[^\p{L}\p{N}%+.-]+/gu, ' ').split(/\s+/).filter(word => word && !stopwords.has(word)).join(' ').slice(0, 120);
    }
    function plainDescription(html) {
      const source = String(html || '').slice(0, 60000).replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, ' ');
      function textOnly(fragment) {
        const stripped = fragment.replace(/<[^>]*>/g, ' ');
        return (new DOMParser().parseFromString(stripped, 'text/html').body.textContent || '').replace(/\s+/g, ' ').trim();
      }
      function intro(fragment) {
        const text = textOnly(fragment).replace(/^(?:(?:clinical|product|ai)\s+summary|at a glance)\s*:\s*/i, '');
        const editorial = /strip shopee|shopee emoji|hospital.grade claims|availability\s*\(?\s*crawl|(?:internal|editorial) (?:note|instruction)|seo (?:title|instruction|keyword)|remove (?:emoji|claims)/i;
        const boilerplate = /^(?:product overview|specifications?|availability|shipping|delivery|returns?|contact|disclaimer|authenticity|sourcing|faq|frequently asked)|official distributors|contact us|whatsapp|email us/i;
        if (text.length < 30 || editorial.test(text) || boilerplate.test(text)) return '';
        if (text.length <= 350) return text;
        let cut = text.slice(0, 347);
        const space = cut.lastIndexOf(' ');
        if (space > 240) cut = cut.slice(0, space);
        return cut.trimEnd() + '...';
      }
      const summary = source.match(/<(div|section|p)\b[^>]*\bid\s*=\s*["'](?:ai-summary|clinical-summary)["'][^>]*>([\s\S]*?)<\/\1\s*>/i);
      if (summary) { const clean = intro(summary[2]); if (clean) return clean; }
      // Keep excerpts ahead of specifications, tables and customer-service sections.
      let boundary = source.search(/<table\b/i);
      if (boundary < 0) boundary = source.length;
      for (const heading of source.matchAll(/<h[1-6]\b[^>]*>([\s\S]*?)<\/h[1-6]\s*>/gi)) {
        if (/specifications?|availability|shipping|delivery|returns?|contact|disclaimer|authenticity|sourcing|faq|frequently asked/i.test(textOnly(heading[1]))) boundary = Math.min(boundary, heading.index);
      }
      const opening = source.slice(0, boundary);
      for (const paragraph of opening.matchAll(/<p\b[^>]*>([\s\S]*?)<\/p\s*>/gi)) {
        const clean = intro(paragraph[1]);
        if (clean && !/\?\s*$/.test(clean)) return clean;
      }
      const firstHeading = opening.search(/<h[1-6]\b/i);
      const beforeHeading = firstHeading < 0 ? opening : opening.slice(0, firstHeading);
      const firstLine = beforeHeading.split(/<br\s*\/?>|[\r\n]+/i).find(line => textOnly(line).length >= 30);
      return firstLine ? intro(firstLine) : '';
    }
    async function publicJson(url, signal) {
      if (!safeUrl(url.href)) throw new Error('Invalid product request');
      const request = new AbortController();
      let timedOut = false;
      const cancel = () => request.abort();
      if (signal.aborted) cancel();
      else signal.addEventListener('abort', cancel, { once: true });
      const timeout = window.setTimeout(() => { timedOut = true; request.abort(); }, 10000);
      try {
        const response = await fetch(url.href, { method: 'GET', mode: 'same-origin', credentials: 'same-origin', redirect: 'error', headers: { Accept: 'application/json' }, signal: request.signal });
        if (!response.ok) throw new Error('Product information unavailable');
        return await response.json();
      } catch (error) {
        if (timedOut) { const unavailable = new Error('Product request timed out'); unavailable.name = 'TimeoutError'; throw unavailable; }
        throw error;
      } finally {
        window.clearTimeout(timeout);
        signal.removeEventListener('abort', cancel);
      }
    }
    function browseSearch(item, query) {
      const url = endpoint('search');
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', query);
      const browse = link('See all matching products', url.href);
      if (browse) { const group = node('div', 'ems-assistant__sources'); group.append(browse); item.append(group); }
    }
    async function showDetails(handle, button) {
      handle = normalizedHandle(handle);
      if (busy || !handle) return;
      const ticket = ++sequence;
      controller = new AbortController();
      if (button) button.disabled = true;
      setBusy(true, 'Checking product details...');
      try {
        const product = await publicJson(endpoint('products/' + encodeURIComponent(handle) + '.js'), controller.signal);
        if (ticket !== sequence || !dialog.open) return;
        const item = message();
        const title = link(product.title || 'View product', endpoint('products/' + encodeURIComponent(handle)).href);
        if (title) { title.className = 'ems-assistant__product-title'; item.append(title); }
        item.append(node('p', 'ems-assistant__product-price', priceRange(product, true) + ' · ' + stockLabel(product.available, true)));
        const description = plainDescription(product.description);
        item.append(node('p', '', description ? 'From the product description: ' + description : 'Open the product page for the full description and instructions.'));
        const variants = Array.isArray(product.variants) ? product.variants : [];
        if (variants.length) {
          item.append(node('p', '', 'Product options:'));
          const list = node('ul', 'ems-assistant__variants');
          variants.slice(0, 6).forEach(variant => {
            const titleText = variant.title === 'Default Title' ? 'Standard option' : variant.title || 'Option';
            const sku = typeof variant.sku === 'string' && variant.sku ? ' · REF/SKU ' + variant.sku : '';
            const price = formatPrice(variant.price, true);
            list.append(node('li', '', titleText + (price ? ' · ' + price : '') + ' · ' + stockLabel(variant.available) + sku));
          });
          item.append(list);
          if (variants.length > 6) item.append(node('p', '', 'More options are listed on the product page.'));
        }
        item.append(node('p', '', 'Confirm your exact option on the product page. For suitability and use, follow the manufacturer instructions and ask your clinician.'));
        helpfulLinks(item);
      } catch (error) {
        if (error.name !== 'AbortError' && ticket === sequence && dialog.open) helpfulLinks(message(error.name === 'TimeoutError' ? 'Product details are taking too long to load. Please try again, open the product page or ask our team for help.' : 'I could not load those product details just now. Open the product page or ask our team for help.'));
      } finally {
        if (button?.isConnected) button.disabled = false;
        if (ticket === sequence) { controller = null; setBusy(false); scrollToLatest(); }
      }
    }
    async function searchProducts(query) {
      const ticket = ++sequence;
      controller = new AbortController();
      setBusy(true, 'Searching the EMIS+ catalogue...');
      try {
        const url = endpoint('search/suggest.json');
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '4');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        const data = await publicJson(url, controller.signal);
        if (ticket !== sequence || !dialog.open) return;
        const products = Array.isArray(data?.resources?.results?.products) ? data.resources.results.products.slice(0, 4) : [];
        if (!products.length) {
          const item = message('I could not find a match for “' + query + '”. Try the brand, a shorter product name or the REF/SKU printed on the box. Our team can also help identify it.');
          browseSearch(item, query);
          helpfulLinks(item);
          return;
        }
        const item = message('Here are current catalogue matches for “' + query + '”. Check the product page for your exact option and final price.');
        const list = node('ul', 'ems-assistant__products');
        products.forEach(product => {
          const productLink = link(product.title || 'View product', product.url);
          if (!productLink) return;
          const card = node('li', 'ems-assistant__product');
          productLink.className = 'ems-assistant__product-title';
          card.append(productLink);
          const prices = node('p', 'ems-assistant__product-price');
          prices.append(node('span', '', priceRange(product)), node('span', 'ems-assistant__stock', stockLabel(product.available, true)));
          card.append(prices);
          if (normalizedHandle(product.handle)) {
            const detail = node('button', 'ems-assistant__detail-button', 'Details & options');
            detail.type = 'button';
            detail.dataset.emsProductDetail = product.handle;
            detail.setAttribute('aria-label', 'Details and options for ' + (product.title || 'this product'));
            card.append(detail);
          }
          list.append(card);
        });
        if (list.childElementCount) item.append(list);
        else item.append(node('p', '', 'Open the full search below or ask our team to help find the product.'));
        browseSearch(item, query);
        scrollToLatest();
      } catch (error) {
        if (error.name !== 'AbortError' && ticket === sequence && dialog.open) {
          const item = message(error.name === 'TimeoutError' ? 'The catalogue search is taking too long to respond. Please try again, open the store search or ask our team to find a product by name or REF.' : 'The catalogue search is unavailable right now. You can open the store search or ask our team to find a product by name or REF.');
          browseSearch(item, query);
          helpfulLinks(item);
        }
      } finally {
        if (ticket === sequence) { controller = null; setBusy(false); scrollToLatest(); }
      }
    }
    function submit(value) {
      if (busy) return;
      const question = String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 400);
      if (!question) return;
      message(question, true);
      input.value = '';
      // Screen before any branch that may send a public catalogue search query.
      if (/\b(password|credit card|card number|otp|medical record|diagnosis|nric)\b|\S+@\S+\.\S+|\b(?:\d[ -]?){13,19}\b/i.test(question)) {
        helpfulLinks(message('Please keep payment and personal medical details out of this conversation. Our team can help with an order or a product question; use your account for order information.'), true);
        return;
      }
      if (/^(hi|hello|hey|thanks|thank you)[.!\s]*$/i.test(question)) {
        message('Hello. Tell me a product name, brand or reference code, or choose a delivery or returns question above.');
        return;
      }
      const marketplace = question.match(/\b(shopee|lazada|tik[ -]?tok(?:\s*shop)?)\b/i);
      if (marketplace && /\b(return(?:s|ed|ing)?|refund(?:s|ed|ing)?|exchang(?:e|es|ed|ing))\b/i.test(question)) {
        const platform = /^shopee$/i.test(marketplace[1]) ? 'Shopee' : /^lazada$/i.test(marketplace[1]) ? 'Lazada' : 'TikTok Shop';
        answerFaq({ answer: 'For your ' + platform + ' purchase, open the order page on that platform and contact its order support about a return, refund or exchange. Marketplace policies may differ from the EMIS+ website policy. You can also contact the EMIS+ team with your order ID for help.', sources: ['contact'], handoff: true });
        return;
      }
      const serviceQuestion = /\b(nurs(?:e|es|ing)|port[ -]?a[ -]?cath|home[ -]?visits?)\b/i.test(question);
      const medicalQuestion = /\b(symptoms?|infection|infected|bleeding|painful|hurts?|redness|pus|oozing|fever|rash|swelling|swollen|burning|itching|allergic|pregnan(?:t|cy)|suitab(?:le|ility)|contraindications?|side effects?|treatment|diagnos(?:e|is)|dosage|prescrib(?:e|ing)|cure)\b|\b(my|i have|i.ve got)\b.*\b(wound|stoma|skin|ulcer|pain|sore)\b|\b(can|should|may) i (use|take|apply)|\bis (it|this|that|\w+).*\bsafe\b/i.test(question);
      if (medicalQuestion) {
        answerFaq({ answer: 'For personal symptoms, a possible infection or whether a product is suitable for you, please speak with your doctor or care nurse. I can help find product information, but cannot assess symptoms or choose treatment. The EMIS+ team can help with product references and support arrangements.', sources: serviceQuestion ? ['contact', 'home-visits'] : ['contact', 'product-faq'], handoff: true });
        return;
      }
      if (serviceQuestion) {
        answerFaq({ answer: 'For nursing, Port-a-Cath or home-visit enquiries and bookings, please contact the EMIS+ team. The team can confirm the service, availability and arrangements for your request.', sources: ['home-visits', 'contact'], handoff: true });
        return;
      }
      if (/\b(this product|this item|current product)\b/i.test(question)) {
        if (root.dataset.productHandle) showDetails(root.dataset.productHandle);
        else helpfulLinks(message('Open a product page and use “About this product”, or enter its name, brand or REF here.'));
        return;
      }
      // Order, contact and medical questions are answered locally rather than sent to product search.
      const faq = priority.map(id => faqs.find(entry => entry.id === id)).find(entry => entry.match.test(question));
      const query = cleanQuery(question);
      if (faq) {
        answerFaq(faq);
        if (faq.id === 'availability' && query.length > 1 && !/\b(restock|expiry|expiration|expire)\b/i.test(question)) searchProducts(query);
        return;
      }
      if (query.length < 2) {
        helpfulLinks(message('I can help with product names, brands, REF/SKU codes, delivery and returns. For a personal order or another question, please contact our team.'), true);
        return;
      }
      searchProducts(query);
    }

    const topics = root.querySelector('[data-ems-assistant-topics]');
    if (topics) faqs.forEach(faq => { const button = node('button', '', faq.title); button.type = 'button'; button.dataset.emsTopic = faq.id; topics.append(button); });
    launcher.addEventListener('click', open);
    root.querySelector('[data-ems-assistant-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', closed);
    form.addEventListener('submit', event => { event.preventDefault(); submit(input.value); });
    root.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || !root.contains(button) || busy) return;
      if (button.dataset.emsTopic) {
        const faq = faqs.find(entry => entry.id === button.dataset.emsTopic);
        if (faq) { message(faq.title, true); answerFaq(faq); }
      } else if (button.hasAttribute('data-ems-current-product')) {
        message('Tell me about this product.', true);
        showDetails(root.dataset.productHandle);
      } else if (button.hasAttribute('data-ems-search-prompt')) {
        message('Enter a brand, product name or reference code below. I’ll find matching products and their current options.');
        input.focus({ preventScroll: true });
      } else if (button.dataset.emsProductDetail) showDetails(button.dataset.emsProductDetail, button);
    });
    window.addEventListener('resize', syncViewport, { passive: true });
    window.visualViewport?.addEventListener('resize', syncViewport, { passive: true });
    launcher.hidden = false;
  }

  function initAll() { document.querySelectorAll('[data-ems-assistant]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
